//MAP INSTANCE
let map;
// variable for marker info window
let infowindow;
// List with all markers.
let markerList = {};

//SET IF UNDEFINED
if (typeof map_sidebar === "undefined"){
    let map_sidebar;
}
if (typeof icon === "undefined"){
    let icon = SITE_FILES + 'images/markers.png';
    console.log(icon);
}
if (typeof button_label === "undefined"){
    let button_label = "Visit Website";
}

if(!zoom_position){
    var zoom_position = 'RIGHT_CENTER';
}

let active_pin;

//define style for map and pass into the load map function.. build using tool @ http://gmaps-samples-v3.googlecode.com/svn/trunk/styledmaps/wizard/index.html
//THIS IS THE DEFAULT MAP STYLE TO USE.
//IF YOU NEED A SPECIALIZED MAP REDEFINE THIS ARRAY IN THE PAGE YOU ARE WORKING ON.
//DO NOT OVERWRITE THE DEFAULT, ONLY REDEFINE IN YOUR PAGE.
let styles = styled;

function initializeMap(lat, long, zoom = 13)
{   
    //SET POSITION OF MAP
    let defaultLatlng = new google.maps.LatLng(lat, long); //set longitude and latitude
    var pos = google.maps.ControlPosition[zoom_position];
    //console.log(pos);
    let myOptions = {
        zoom: zoom,
        center: defaultLatlng,
        mapTypeId: typeof map_type === "undefined" ? "roadmap" : map_type,
        mapTypeControl : false,
        scrollwheel: false,
        disableDoubleClickZoom : false,
        backgroundColor : '#ffffff',
        styles : styles,
        panControl: false,
        zoomControl: true,
        //zoomControlOptions: {
        //    position: pos
        //}
    };

    // create new map make sure a DIV with id myMap exist on page
    map = new google.maps.Map(document.getElementById("myMap"), myOptions); //generate map into div id myMap

    // create new info window for marker detail pop-up
    let infoBoxOptions = {
        content: '',
        disableAutoPan: false,
        pixelOffset: new google.maps.Size(-140, 5),
        zIndex: null,
        closeBoxMargin: "-8px -8px -11px 2px",
        closeBoxURL: `${path+folder}/close.png`,
        infoBoxClearance: new google.maps.Size(6, 6),
        isHidden: false,
        pane: "floatPane",
        alignBottom : false,
        enableEventPropagation: false
    };

    infowindow = new InfoBox(infoBoxOptions); //create the infoBox. will begin as hidden but then we show and hide this.
}

/**
 * Load marker to map
 */
function loadMarker(markerData, markerZindex){ //writes the marker to the map. pass a javascript object with the markers longitude latitude id and name so that the code can keep track of all the markers.
    let pin_icon = markerData['icon'];

    let myLatlng = new google.maps.LatLng(markerData['lat'],markerData['long']);

    if( markerData['icon'] === '' || !markerData.hasOwnProperty('icon') ) { icon = SITE_FILES + 'images/markers.png'; } //fall back on default marker

    // create new marker
    let marker = new google.maps.Marker({
        id: parseInt(markerData['id']),
        map: map,
        title: markerData['name'],
        icon : pin_icon,
        walking : markerData["walking"],
        biking : markerData["biking"],
        driving : markerData["driving"],
        position: myLatlng,
        zIndex: markerZindex
    });

    // add marker to list used later to get content and additional marker information
    markerList[marker.id] = marker;

    // add event listener when marker is clicked
    google.maps.event.addListener(marker, 'click', () => {
            let i;
        for (i in markerList) {
            if(markerList[i].id !== 0){
                // markerList[i].setIcon(icon);
            }
        }

        if (  typeof map_sidebar !== "undefined" && map_sidebar) {
            slick_pins.slick('slickGoTo', marker.id);
        }else{
            showMarker(marker.id, markerData.name, markerData.thumb, markerData.description, markerData.walking, markerData.biking, markerData.driving, markerData.url);
        }
        
        map.panTo(marker.getPosition());

        if (marker.id !== 0) {
            // marker.setIcon(icon2);
        }
        return active_pin = marker.id;

    });

    // google.maps.event.addListener(marker, 'mouseover', () => {
    //     if (marker.id !== 0) {
    //         marker.setIcon(icon2);
    //     }
    // });

    // google.maps.event.addListener(marker, 'mouseout', () => {
    //     if (marker.id !== 0 && marker.id !== active_pin) {
    //         marker.setIcon(icon);
    //     }
    // });

}


/**
 * Show marker info window. when marker is clicked, this function is called.
 */
function showMarker(markerId, name, thumb, description, walking = "", biking = "", driving = "", url){
    // get marker information from marker list
    let marker = markerList[markerId];

    // check if marker was found
    if( marker ){
        //generate the html that will go in the popup. generate the popup content using these string templates. customize these to your needs. can have as many string templates as needed.
        let html_string =
            `<div class="map_popup">
                    ${ thumb !== "" ? `<img src="${thumb}" alt="photo of ${name}">` : "" }
                        <div class="desc">
                        <h2>${name}</h2>
                        ${ walking !== "" ? `<h3 class="walking-distance">${ walking }</h3>` : ""}
                        ${ biking !== "" ? `<h3 class="biking-distance">${ biking }</h3>` : ""}
                        ${ driving !== "" ? `<h3 class="driving-distance">${ driving }</h3>` : ""}
                        <p>${description}</p>
                        ${ url !== "" ? `<a href="${url}" class="btn" target="_blank">${button_label !== "" ? button_label : "Visit Website"}</a>` : "" }
                    </div>
                </div>`;

        infowindow.setContent(html_string); //write the html to the info window
        infowindow.open(map,marker); //show the info window

    }else{
        alert('Error marker not found: ' + markerId);
    }
}